import { Model } from '@/models/Model';
import { SupplierSize } from './SupplierSize';

export class SupplierSizePack extends Model{
  protected $name: string = 'SupplierSizePack';

  protected $endpoint: string = '/supplier-size-pack';

  protected $fillable: string[] = [
    'name',
    'description',
    'size_ids',
  ];

  protected $includes: SupplierSizePackIncludeType[] = [];

  public id?: string;
  public name?: string;
  public description?: string;
  public size_ids?: string[];
  public sizes?: SupplierSize[];

  public include(includes: SupplierSizePackIncludeType | SupplierSizePackIncludeType[]): this {
    return super.include.call(this, includes);
  }
}

export type SupplierSizePackIncludeType = 'sizes';
